import { render, staticRenderFns } from "./DocketEntryEditorDialog.vue?vue&type=template&id=31780f55&scoped=true&"
import script from "./DocketEntryEditorDialog.vue?vue&type=script&lang=js&"
export * from "./DocketEntryEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocketEntryEditorDialog.vue?vue&type=style&index=0&id=31780f55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31780f55",
  null
  
)

export default component.exports